import { Link } from "react-router-dom";
import type { ReactNode } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export function AuthScreen({
  title,
  description,
  children,
}: {
  title: string;
  description: string;
  children: ReactNode;
}) {
  return (
    <main className="flex min-h-[100dvh] flex-col items-center justify-center bg-gradient-to-b from-saffron-50 via-background to-background px-6 py-10">
      <Card className="w-full max-w-sm border-saffron-100/80 shadow-none">
        <CardHeader className="space-y-2 text-center">
          <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-saffron-700">
            ISKCON Pune · BCEC
          </p>
          <CardTitle className="text-2xl font-semibold tracking-tight">
            {title}
          </CardTitle>
          <CardDescription className="text-pretty">{description}</CardDescription>
        </CardHeader>
        <CardContent>
          {children}
          <p className="mt-5 text-center text-sm text-muted-foreground">
            <Link to="/" className="text-saffron-700 hover:underline">
              Back
            </Link>
          </p>
        </CardContent>
      </Card>
    </main>
  );
}
